import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
import { baseHighlightStyle } from '../tokens/highlight';
export var buttonCursorMixin = css(_templateObject(), baseHighlightStyle, function (_ref) {
  var as = _ref.as,
      forwardedAs = _ref.forwardedAs,
      onClick = _ref.onClick,
      href = _ref.href,
      inactive = _ref.inactive,
      disabled = _ref.disabled,
      clickable = _ref.clickable;
  return (onClick || href || clickable || as === 'button' || as === 'label' || as === 'a' || forwardedAs === 'button' || forwardedAs === 'label' || forwardedAs === 'a') && !inactive && !disabled && "\n    cursor: pointer;\n  ";
});
export var buttonCursorKeys = ['as', 'forwardedAs', 'href', 'inactive', 'disabled', 'clickable', 'onClick'];